export default function (Component) {
Component.options.__docs = "<p>You can put other components (for example a simple <code>FdButton</code>) in <code>FdTableCell</code>.</p>\n"
}